import { FC } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Form, Formik, FormikProps } from 'formik';
import { AssertionsType } from 'entities/Assertions/types';
import { isEmptyObject } from 'shared/helpers/isEmptyObject';
import { isEmptyObjectValues } from 'shared/helpers/isEmptyObjectValues';
import { ActionsForDialog } from 'shared/ui/ActionsForDialog';
import { InputField } from 'shared/ui/InputField';
import { Paper } from 'shared/ui/Paper';
import { AssertionEditorValidationSchema } from 'widgets/Extensions/Details/ui/AssertionSets/ui/AsModals/AssertionsEditor/consts/validation';
import { AssertionEditorType } from 'widgets/Extensions/Details/ui/AssertionSets/ui/AsModals/AssertionsEditor/types';

interface Props {
	title: string;
	open: boolean;
	handleSubmit: (values: AssertionEditorType) => void;
	handleClose: () => void;
	assertionToEdit?: AssertionsType | null;
}

export const AssertionEditor: FC<Props> = ({ title, open, handleSubmit, handleClose, assertionToEdit }) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={handleClose} PaperComponent={Paper} PaperProps={{ title }}>
			<Formik
				initialValues={{
					initialVal: assertionToEdit?.initialVal || '',
					replaceVal: assertionToEdit?.replaceVal || '',
				}}
				validationSchema={AssertionEditorValidationSchema}
				onSubmit={handleSubmit}
			>
				{({ errors, values, resetForm }: FormikProps<AssertionEditorType>) => (
					<Form>
						<InputField
							name="initialVal"
							label={t('assertions.label.initial_value')}
							placeholder={t('assertions.placeholder.initial_value') as string}
							multiline
							disabled={!!assertionToEdit}
							required
						/>
						<InputField
							name="replaceVal"
							label={t('assertions.label.replaced_value')}
							placeholder={t('assertions.placeholder.replaced_value')}
							required
						/>

						<ActionsForDialog
							cancelLabel={t('shared_texts.cancel')}
							cancelAction={() => {
								resetForm();
								handleClose();
							}}
							applyLabel={t('shared_texts.save')}
							applyActionDisabled={!isEmptyObject(errors) || isEmptyObjectValues(values)}
						/>
					</Form>
				)}
			</Formik>
		</Dialog>
	);
};
